import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import ListedCoinInfo from "./ListedCoinInfo";
import ZLaunchCoinInfo from "./ZLaunchCoinInfo";
import "./style.scss";

export const COIN_INFO_TYPES = {
  LISTED_COIN: "LISTED_COIN",
  ZLAUNCH_COIN: "ZLAUNCH_COIN",
};

const CoinInfoLayout = ({ data, coinType }) => {
  const { t } = useContext(CustomI18nextContext);
  const [_coinType, _setCoinType] = useState("");

  const isListedCoinType = _coinType === COIN_INFO_TYPES.LISTED_COIN;
  const isZLaunchCoinType = _coinType === COIN_INFO_TYPES.ZLAUNCH_COIN;

  useEffect(() => {
    _setCoinType(coinType);
  }, [coinType]);

  const CoinTab = ({ type, label }) => (
    <button
      className={cx("coin-info__tab button", { active: _coinType === type })}
      onClick={() => _setCoinType(type)}
    >
      {label}
    </button>
  );

  return (
    <div id="coin-info" className="pt-5">
      <div className="container mb-5 py-5 page-content">
        <h1 className="text-center mb-4">{t("coinInfo.title")}</h1>
        <div className="row justify-content-center mx-2 mx-sm-5">
          <div className="col-12 d-flex justify-content-center mt-3 mb-5">
            <CoinTab
              type={COIN_INFO_TYPES.LISTED_COIN}
              label={t("coinInfo.listedCoins")}
            />
            <CoinTab
              type={COIN_INFO_TYPES.ZLAUNCH_COIN}
              label={t("coinInfo.zLaunchCoins")}
            />
          </div>
          {isListedCoinType && (
            <ListedCoinInfo
              coinZMT={data.coinZMT}
              listedCoins={data.listedCoins}
              newListedCoins={data.newListedCoins}
            />
          )}
          {isZLaunchCoinType && <ZLaunchCoinInfo coins={data.zLaunchCoins} />}
        </div>
      </div>
    </div>
  );
};

CoinInfoLayout.propTypes = {
  data: PropTypes.any,
  coinType: PropTypes.oneOf([
    COIN_INFO_TYPES.LISTED_COIN,
    COIN_INFO_TYPES.ZLAUNCH_COIN,
  ]).isRequired,
};
export default CoinInfoLayout;
